// extracted by mini-css-extract-plugin
export var bodyLink = "NoticeModule-module--bodyLink--XZ7+0";
export var bodyLinkwrapper = "NoticeModule-module--bodyLinkwrapper--FKUeD";
export var button = "NoticeModule-module--button--BJiVK";
export var component = "NoticeModule-module--component--Bi16k";
export var linkWrapper = "NoticeModule-module--linkWrapper--BGM8V";
export var noticeText = "NoticeModule-module--noticeText--N1YQQ";
export var title = "NoticeModule-module--title--JZdIL";